/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Recovery_CopyInputs */

const en_two_fa_recovery_copy = /** @type {(inputs: Two_Fa_Recovery_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy all codes`)
};

const nl_two_fa_recovery_copy = /** @type {(inputs: Two_Fa_Recovery_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle codes kopiëren`)
};

/**
* | output |
* | --- |
* | "Copy all codes" |
*
* @param {Two_Fa_Recovery_CopyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_recovery_copy = /** @type {((inputs?: Two_Fa_Recovery_CopyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Recovery_CopyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_recovery_copy(inputs)
	return en_two_fa_recovery_copy(inputs)
});